/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getPatient = /* GraphQL */ `query GetPatient($id: ID!) {
  getPatient(id: $id) {
    id
    facilityId
    karteNo
    zipCode
    address
    state
    city
    familyName
    firstName
    familyNameKana
    firstNameKana
    email
    phoneNumber
    dateOfBirth
    gender
    mynumbercard
    seinenhikoukennin
    vip
    memberStatus
    contractState {
      clinicName
      termsAgree
      infoAgree
      __typename
    }
    kaisekiKenriNoKyodaku
    eturankenKyodaku
    tokumeiKakouJouhouHukuseiNoKyodaku
    koukokuUketoriNoKyodaku
    minimumAdvertisedPrice
    designationOfMinimumTransactionPrice
    kouekiKenkyuuMushouRiyou
    houkatuDoui
    torihikiGoui
    tudoKeiyakuKakunin
    lineUserId
    isWalletCreate
    createdAt
    updatedAt
    isLineNotificationEnabled
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPatientQueryVariables,
  APITypes.GetPatientQuery
>;
export const listPatients = /* GraphQL */ `query ListPatients(
  $filter: ModelPatientFilterInput
  $limit: Int
  $nextToken: String
) {
  listPatients(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      facilityId
      karteNo
      zipCode
      address
      state
      city
      familyName
      firstName
      familyNameKana
      firstNameKana
      email
      phoneNumber
      dateOfBirth
      gender
      mynumbercard
      seinenhikoukennin
      vip
      memberStatus
      kaisekiKenriNoKyodaku
      eturankenKyodaku
      tokumeiKakouJouhouHukuseiNoKyodaku
      koukokuUketoriNoKyodaku
      minimumAdvertisedPrice
      designationOfMinimumTransactionPrice
      kouekiKenkyuuMushouRiyou
      houkatuDoui
      torihikiGoui
      tudoKeiyakuKakunin
      lineUserId
      isWalletCreate
      createdAt
      updatedAt
      isLineNotificationEnabled
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPatientsQueryVariables,
  APITypes.ListPatientsQuery
>;
export const getReservation = /* GraphQL */ `query GetReservation($id: ID!) {
  getReservation(id: $id) {
    id
    patientId
    symptoms
    symptomOthers
    examinationMenuId
    remarks
    dateTime
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReservationQueryVariables,
  APITypes.GetReservationQuery
>;
export const listReservations = /* GraphQL */ `query ListReservations(
  $filter: ModelReservationFilterInput
  $limit: Int
  $nextToken: String
) {
  listReservations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      patientId
      symptoms
      symptomOthers
      examinationMenuId
      remarks
      dateTime
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReservationsQueryVariables,
  APITypes.ListReservationsQuery
>;
export const getObservation = /* GraphQL */ `query GetObservation($id: ID!) {
  getObservation(id: $id) {
    id
    patientId
    reservationId
    height
    weight
    treatmentOfRecentInjuriesReceived
    purposeOfExamination
    purposeOfExaminationOtherReason
    areaToBeInspected
    jobType
    jobTypeOtherReason
    workplaceTransferMethod
    workplaceTransferMethodOtherReason
    walkingHabit
    aidsForWalking
    createdInHospitalsAndClinics
    insuranceCoverageForOrthoticDevices
    unintentionalWeightLossOfMoreThan2kgInTheLast6Months
    feelingTiredForNoReasonInTheLastTwoWeeks
    lightExerciseForHealthPurposes
    canYouOpenTheLidOfAPlasticBottle
    diseasesRelatedToOrthopedics
    sprainLocation
    fractureLocation
    diseasesRelatedToOrthopedicsOtherReason
    injuries1
    injuries2
    nameOfDrugAllergyMedication
    nameOfMedicationIfAllergicToAnesthesia
    otherAllergies
    otherAllergiesOtherReason
    medicationsCurrentlyBeingTaken
    medicationsCurrentlyBeingTakenOtherReason
    supplementsCurrentlyBeingTaken
    aboutCigarettes
    numberOfCigarettesSmokedDaily
    numberOfYearsSmoked
    aboutAlcohol
    pregnancy
    historyOfChildbirth
    aboutFamilyDoctor
    primaryNursingCareRequirementAuthorization
    footSymptomsOfConcern
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetObservationQueryVariables,
  APITypes.GetObservationQuery
>;
export const listObservations = /* GraphQL */ `query ListObservations(
  $filter: ModelObservationFilterInput
  $limit: Int
  $nextToken: String
) {
  listObservations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      patientId
      reservationId
      height
      weight
      treatmentOfRecentInjuriesReceived
      purposeOfExamination
      purposeOfExaminationOtherReason
      areaToBeInspected
      jobType
      jobTypeOtherReason
      workplaceTransferMethod
      workplaceTransferMethodOtherReason
      walkingHabit
      aidsForWalking
      createdInHospitalsAndClinics
      insuranceCoverageForOrthoticDevices
      unintentionalWeightLossOfMoreThan2kgInTheLast6Months
      feelingTiredForNoReasonInTheLastTwoWeeks
      lightExerciseForHealthPurposes
      canYouOpenTheLidOfAPlasticBottle
      diseasesRelatedToOrthopedics
      sprainLocation
      fractureLocation
      diseasesRelatedToOrthopedicsOtherReason
      injuries1
      injuries2
      nameOfDrugAllergyMedication
      nameOfMedicationIfAllergicToAnesthesia
      otherAllergies
      otherAllergiesOtherReason
      medicationsCurrentlyBeingTaken
      medicationsCurrentlyBeingTakenOtherReason
      supplementsCurrentlyBeingTaken
      aboutCigarettes
      numberOfCigarettesSmokedDaily
      numberOfYearsSmoked
      aboutAlcohol
      pregnancy
      historyOfChildbirth
      aboutFamilyDoctor
      primaryNursingCareRequirementAuthorization
      footSymptomsOfConcern
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListObservationsQueryVariables,
  APITypes.ListObservationsQuery
>;
export const getReception = /* GraphQL */ `query GetReception($id: ID!) {
  getReception(id: $id) {
    id
    patientId
    date
    outpatientId
    outpatientName
    startTime
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReceptionQueryVariables,
  APITypes.GetReceptionQuery
>;
export const listReceptions = /* GraphQL */ `query ListReceptions(
  $filter: ModelReceptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listReceptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      patientId
      date
      outpatientId
      outpatientName
      startTime
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReceptionsQueryVariables,
  APITypes.ListReceptionsQuery
>;
export const getContract = /* GraphQL */ `query GetContract($id: ID!) {
  getContract(id: $id) {
    id
    clinicName
    isMedical
    medicalTreatment {
      title
      detail
      __typename
    }
    infoAgree
    termsAndConditions
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetContractQueryVariables,
  APITypes.GetContractQuery
>;
export const listContracts = /* GraphQL */ `query ListContracts(
  $filter: ModelContractFilterInput
  $limit: Int
  $nextToken: String
) {
  listContracts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      clinicName
      isMedical
      infoAgree
      termsAndConditions
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListContractsQueryVariables,
  APITypes.ListContractsQuery
>;
export const getNotification = /* GraphQL */ `query GetNotification($id: ID!) {
  getNotification(id: $id) {
    id
    patientId
    facilityId
    patientIdFacilityId
    createdAt
    altText
    title
    message
    notificationType
    buttonType
    actionType
    actionValue
    choices
    isRead
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNotificationQueryVariables,
  APITypes.GetNotificationQuery
>;
export const listNotifications = /* GraphQL */ `query ListNotifications(
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      patientId
      facilityId
      patientIdFacilityId
      createdAt
      altText
      title
      message
      notificationType
      buttonType
      actionType
      actionValue
      choices
      isRead
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationsQueryVariables,
  APITypes.ListNotificationsQuery
>;
export const notificationsByPatientId = /* GraphQL */ `query NotificationsByPatientId(
  $patientId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  notificationsByPatientId(
    patientId: $patientId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      patientId
      facilityId
      patientIdFacilityId
      createdAt
      altText
      title
      message
      notificationType
      buttonType
      actionType
      actionValue
      choices
      isRead
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByPatientIdQueryVariables,
  APITypes.NotificationsByPatientIdQuery
>;
export const notificationsByPatientIdFacilityIdAndCreatedAt = /* GraphQL */ `query NotificationsByPatientIdFacilityIdAndCreatedAt(
  $patientIdFacilityId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  notificationsByPatientIdFacilityIdAndCreatedAt(
    patientIdFacilityId: $patientIdFacilityId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      patientId
      facilityId
      patientIdFacilityId
      createdAt
      altText
      title
      message
      notificationType
      buttonType
      actionType
      actionValue
      choices
      isRead
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByPatientIdFacilityIdAndCreatedAtQueryVariables,
  APITypes.NotificationsByPatientIdFacilityIdAndCreatedAtQuery
>;
export const getRetryNotifications = /* GraphQL */ `query GetRetryNotifications($id: ID!) {
  getRetryNotifications(id: $id) {
    id
    sendMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRetryNotificationsQueryVariables,
  APITypes.GetRetryNotificationsQuery
>;
export const listRetryNotifications = /* GraphQL */ `query ListRetryNotifications(
  $id: ID
  $filter: ModelRetryNotificationsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listRetryNotifications(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      sendMessage
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRetryNotificationsQueryVariables,
  APITypes.ListRetryNotificationsQuery
>;
export const getFacilityPatients = /* GraphQL */ `query GetFacilityPatients($patientId: ID!, $facilityId: ID!) {
  getFacilityPatients(patientId: $patientId, facilityId: $facilityId) {
    facilityId
    patientId
    lineUserId
    karteNo
    vip
    isFirstVisit
    memberStatus
    insuranceType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFacilityPatientsQueryVariables,
  APITypes.GetFacilityPatientsQuery
>;
export const listFacilityPatients = /* GraphQL */ `query ListFacilityPatients(
  $patientId: ID
  $facilityId: ModelIDKeyConditionInput
  $filter: ModelFacilityPatientsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFacilityPatients(
    patientId: $patientId
    facilityId: $facilityId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      facilityId
      patientId
      lineUserId
      karteNo
      vip
      isFirstVisit
      memberStatus
      insuranceType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFacilityPatientsQueryVariables,
  APITypes.ListFacilityPatientsQuery
>;
export const facilityPatientsByLineUserId = /* GraphQL */ `query FacilityPatientsByLineUserId(
  $lineUserId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelFacilityPatientsFilterInput
  $limit: Int
  $nextToken: String
) {
  facilityPatientsByLineUserId(
    lineUserId: $lineUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      facilityId
      patientId
      lineUserId
      karteNo
      vip
      isFirstVisit
      memberStatus
      insuranceType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FacilityPatientsByLineUserIdQueryVariables,
  APITypes.FacilityPatientsByLineUserIdQuery
>;
export const listFacilityPatientsByFacilityIdAndKarteNo = /* GraphQL */ `query ListFacilityPatientsByFacilityIdAndKarteNo(
  $karteNo: String!
  $facilityId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFacilityPatientsFilterInput
  $limit: Int
  $nextToken: String
) {
  listFacilityPatientsByFacilityIdAndKarteNo(
    karteNo: $karteNo
    facilityId: $facilityId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      facilityId
      patientId
      lineUserId
      karteNo
      vip
      isFirstVisit
      memberStatus
      insuranceType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFacilityPatientsByFacilityIdAndKarteNoQueryVariables,
  APITypes.ListFacilityPatientsByFacilityIdAndKarteNoQuery
>;
